import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  meta: {
    title: {
      de: 'E-Commerce Plattformen für B2B & B2C - Maßgeschneiderte Shop-Lösungen',
      en: 'E-Commerce Platforms for B2B & B2C - Custom Shop Solutions'
    },
    description: {
      de: 'Wir entwickeln zukunftssichere E-Commerce Plattformen für B2B & B2C. Maßgeschneidert, skalierbar und perfekt auf deine Geschäftsprozesse abgestimmt.',
      en: 'We develop future-proof e-commerce platforms for B2B & B2C. Tailored, scalable and perfectly adapted to your business processes.'
    }
  },
  hero: {
    title: {
      de: 'Zukunftssichere E-Commerce Plattformen',
      en: 'Future-proof E-Commerce Platforms'
    },
    description: {
      de: 'Wir entwickeln maßgeschneiderte B2B & B2C Shop-Lösungen, die Conversion, Umsatz und Kundenerlebnis revolutionieren.',
      en: 'We develop customized B2B & B2C shop solutions that revolutionize conversion, revenue and customer experience.'
    },
    details: {
      de: 'Datengetrieben, KI-optimiert und perfekt auf deine Geschäftsprozesse abgestimmt – unsere E-Commerce Plattformen wachsen mit deinem Unternehmen und setzen neue Maßstäbe für digitalen Handel.',
      en: 'Data-driven, AI-optimized and perfectly aligned with your business processes – our e-commerce platforms grow with your company and set new standards for digital commerce.'
    }
  },
  cta: {
    primary: {
      de: 'Lösungen entdecken',
      en: 'Discover Solutions'
    },
    secondary: {
      de: 'Strategie-Gespräch vereinbaren',
      en: 'Schedule Strategy Call'
    }
  }
}); 